import { ListItem, Section } from '@/components';
import {
  UnderlyingYieldBearingAssetInterface,
  YieldBearingAssetInterface,
} from '@/interfaces';
import { formatNumberToAPYString } from '@/utils/formatUtils';
import { FC } from 'react';
import { HiChartBar } from 'react-icons/hi';
type ReturnSectionProps = {
  label?: string;
  returnRate?: number | null;
  asset?: UnderlyingYieldBearingAssetInterface | YieldBearingAssetInterface;
};
const ReturnIcon = HiChartBar as React.ComponentType<any>;
const ReturnSection: FC<ReturnSectionProps> = ({
  label = 'Return',
  returnRate,
  asset,
}) => {
  const rate = returnRate ?? asset?.apy;
  if (rate === null || rate === undefined) {
    return null;
  }
  return (
    <Section
      body={
        <ListItem
          leftIcon={<ReturnIcon className="text-secondary" />}
          leftIconWidth={33}
          leftIconHeight={33}
          mainText={formatNumberToAPYString(rate)}
          mainTextColor={'primary'}
          subText={label}
          subTextSize={'caption'}
        />
      }
    />
  );
};
export default ReturnSection;
